<template>
  <div class="articleInfo">
    <div class="row-wrap">
      <el-row :gutter="10">
        <el-col :span="19"
                class="content-wrap">
          <div class="code-wrap">
            <QRCode :value="tuneContentUrl"
                    :options="{size: 120}"></QRCode>
            <div class="code-label">微信扫码分享</div>
          </div>
          <div class="article-info-wrap">
            <div class="article-info">
              <div class="data-info"
                   v-loading="loadSate">
                <div class="data-title">{{formDetail.title}}</div>

                <div class="data-author"
                     v-if="formDetail.author">{{formDetail.author}}
                  <div class="data-date">{{formDetail.publishTime}}</div>
                </div>
                <!-- 标签 -->
                <div class="labels">
                  <span class="label">关键字：</span>
                  <span v-if="keywords.length">
                    <el-tag v-for="item in keywords"
                            :key="item"
                            effect="dark">
                      {{ item }}
                    </el-tag>
                  </span>
                </div>
                <div class="labels">
                  <span class="label">标签：</span>
                  <span v-if="labels.length">
                    <el-tag v-for="item in labels"
                            :key="item"
                            effect="dark">
                      {{ item }}
                    </el-tag>
                  </span>
                </div>
                <!-- 文章正文 -->
                <div class="article-content"
                     v-html="formDetail.content">
                </div>
                <!-- 附件 -->
                <div v-if="attachmentList.length"
                     class="attach">
                  <div>附件：</div>
                  <div v-for="item in attachmentList"
                       v-bind:key="item.id">
                    <a :href="item.fileUrl"
                       onclick="javascript:void(0);"
                       style="color: red;">
                      {{item.name}}
                    </a>
                  </div>
                </div>
              </div>

              <!-- <div class="data-option">
                <span class="number"
                      :class="{'active': formDetail.currentUserIsAddFavorite}"
                      @click="favorite">
                  <icon-svg name="star"></icon-svg>{{!formDetail.currentUserIsAddFavorite ? '收藏' : '取消收藏'}}
                </span>
                <span class="number"
                      @click="oncomment">
                  <icon-svg name="comment"></icon-svg>{{commentCount || 0}}
                </span>
                <span class="number"
                      :class="{'active': formDetail.thumbCount}"
                      @click="onzan">
                  <icon-svg name="zan"></icon-svg>{{formDetail.thumbCount || 0}}
                </span>
                <span class="number">
                  <icon-svg name="eye"></icon-svg>{{formDetail.viewCount || 0}}
                </span>
              </div> -->
            </div>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="code-advert">
            <img src="../assets/img/headlines/wxCode.jpg"
                 alt="">
            <img src="../assets/img/headlines/user.png"
                 alt="总裁讲座定制">
          </div>

          <div class="contact">
            <p>想建供应链平台 </p>
            <p>就找海平老师</p>
            <p>微信号sz_scm</p>
          </div>

          <div class="customer">
            <div v-for="(cus, c) in customers"
                 :key="c"
                 @click="openUrl(cus.url)"
                 class="customer-item">
              <img :src="cus.logo"
                   alt="">
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
import QRCode from '@xkeshi/vue-qrcode'
export default {
  name: 'articleInfo',
  components: { QRCode },
  data () {
    return {
      tuneContentUrl: '',
      formDetail: {},
      customers: [
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/0A7479B5E691CB87.png', url: 'http://www.dachuangtech.com/#/index' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/6CE4961C58589425.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/22A4B673F656C3C7.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/0F74BDB4E4F7ECDB.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/B83426CD96E82DFE.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/16D45AF39AB56141.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/2B4459C8254471B8.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/5644128A24F52C3E.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/CA2492AFEF7BB891.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/44748258201B5772.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/2C147D64D375EA1B.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/4B649F49B7FB1BB5.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/4FC443ED196E1481.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/FD841BB5A68557FF.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/34F4AB6E69576B28.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/40149AD0A17AEE17.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/89E44AE28537CDA5.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/BFD40075AEDB3668.png', url: '' }
      ],
      articlesList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  mounted () {
    let id = this.$route.query.id
    this.viewExplain(id)

    this.tuneContentUrl = 'http://iportal.zhongpukeji.cn/#/mobile-report-info?id=' + id
  },
  methods: {
    openUrl (url) {
      url && window.open(url)
    },
    info (val) {
      let routeData = this.$router.resolve({
        name: 'articleInfo',
        query: { id: val.id }
      })
      window.open(routeData.href, '_blank')
    },
    viewExplain (id) {
      this.$http({
        url: this.$http.adornUrl('/crmapi/dccms/article/view?id=' + id),
        method: 'get'
      })
        .then(res => {
          if (res.data && res.data.code === 'C0000') {
            this.formDetail = res.data.result ? res.data.result : {}
            this.labels = this.formDetail.labels ? this.formDetail.labels.split(',') : []
            this.keywords = this.formDetail.keywords ? this.formDetail.keywords.split(',') : []
            this.attachmentList = res.data.result.attachmentList || []
          } else {
            this.$message.error(res.data.message)
            this.editorHtml = ''
          }
        }).catch(() => {
          this.editorHtml = ''
        })
    }
  }
}
</script>

<style lang="scss">
.article-content {
  line-height: 32px;
  img {
    max-width: 100% !important;
    width: -webkit-fill-available;
  }
}
</style>
<style lang="scss" scoped>
.content-wrap {
  position: relative;
  .code-wrap {
    position: absolute;
  }
}
.data-option {
  font-size: 14px;
  text-align: right;
  margin-top: 10px;
  .icon-svg {
    width: 20px;
    height: 20px;
    vertical-align: -0.3em;
    margin-right: 4px;
    --primary-color: #aaa;
    --secondary-color: #aaa;
  }
  .number {
    color: #555;
    display: inline-block;
    margin-left: 30px;
    cursor: pointer;
    box-sizing: content-box;
  }
  .active {
    color: #1d74ff;
    .icon-svg {
      --primary-color: #1d74ff;
      --secondary-color: #1d74ff;
    }
  }
}
.el-tag {
  margin-right: 6px;
}
.code-label {
  font-size: 12px;
  color: #888;
  text-align: center;
}
.article-info-wrap {
  padding-left: 130px;
}
.article-info {
  background: #fff;
  padding: 20px;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  .advert {
    padding-top: 44px;
    position: absolute;
    width: 260px;
    right: -60px;
    top: 0;
    img {
      width: 260px;
      margin-top: 20px;
    }
  }
  .title {
    color: #31478f;
    font-size: 16px;
    font-weight: bold;
    border-left: 2px solid #0078ff;
    padding-left: 20px;
    margin-bottom: 20px;
    span {
      float: right;
      color: #0078ff;
      font-size: 14px;
      cursor: pointer;
      font-weight: normal;
      .icon-svg {
        width: 30px;
        height: 30px;
        margin-top: -6px;
      }
    }
    span:hover {
      color: #0078ff;
    }
  }
  .data-info {
    min-height: 300px;
    .data-title {
      font-size: 26px;
      border-bottom: 1px dotted #cbdbef;
      padding-bottom: 14px;
      color: #000;
    }

    .data-author {
      padding: 10px 0;
      font-size: 12px;
      position: relative;
      color: #8a94a8;
      .data-date {
        position: absolute;
        right: 0;
        top: 14px;
      }
    }

    .labels {
      padding-top: 6px;
      .label {
        display: inline-block;
        width: 60px;
        color: #888;
        font-size: 12px;
      }
      .el-tag {
        height: 25px;
        line-height: 23px;
      }
    }
  }
}
.articleInfo {
  background: #e5e5e5;
  .row-wrap {
    width: 1200px;
    margin: auto;
    padding: 10px 0;
  }
}
.code-advert {
  padding: 10px;
  background: #fff;
  img {
    width: 100%;
  }
}
.contact {
  background: #f88d0b;
  color: #fff;
  text-align: center;
  padding: 20px 0;
  margin-top: 10px;
  p {
    margin: 10px 0;
  }
  p:first-child {
    font-size: 16px;
  }
  p:last-child {
    font-size: 14px;
  }
}
.customer {
  margin-top: 10px;
}
.customer-item {
  width: 100%;
  height: 90px;
  background: #fff;
  margin-bottom: 1px;
  text-align: center;
  line-height: 90px;
  cursor: pointer;
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/articleInfo.vue